/** An element 'toggle' event that assists in unifying Mouse and Touch Events
    over Mobile and Desktop Platforms
*/
export default class Toggle extends CustomEvent {
    constructor(caller) {
        super('toggle', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
